import Service from '@/service/index.js';
export default {
  props: {
    purchaseInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    userInfo: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      purchaseTypeArr: [],
      citytitle: ''
    };
  },
  created () {
    Service.getSelectList('PURCHASE_TYPE').then(res => {
      if (res && res.code === '0') {
        this.purchaseTypeArr = res.data;
      }
    });
  }
};
